import i18next from "@/i18n";

const resourceByKey = (key: string) =>
	// @ts-expect-error
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	i18next.t(($) => $[key], {
		defaultValue: key,
	}) as string;

export function translateErrorCode(code: string) {
	const key = `common.errors.${code}`;

	const translation = resourceByKey(key);

	return translation === key ? i18next.t(($) => $.common.errors.generic) : translation;
}
